import { apiRoutes } from '@features/users/list/consts/apiRoutes.ts';
import { apiClient } from '@shared/api/ApiClient.ts';
import { ConfigResponseTypes } from '@shared/types/apiClient.ts';

export async function downloadSMBUsers(): Promise<Blob | null> {
  return await apiClient.get<Blob>(apiRoutes.downloadSMBUsersList(), undefined, ConfigResponseTypes.BLOB);
}
